import { makeObservable, observable } from "mobx";

class BrowserState {
    @observable public width = 0;
    @observable public height = 0;
    @observable public mouseX = 0;
    @observable public mouseY = 0;

    constructor() {
        makeObservable(this);
    }
}

const browserState = new BrowserState();

function onResize() {
    browserState.width = window.innerWidth;
    browserState.height = window.innerHeight;
}
onResize();
window.onresize = onResize;
window.onorientationchange = onResize;

function onMouseMove(e: MouseEvent) {
    browserState.mouseX = Math.floor(e.clientX);
    browserState.mouseY = Math.floor(e.clientY);
}
window.onmousemove = onMouseMove;

export { browserState };
